export const WorkData = [
  {
    company: "DH Hub",
    designation: "Front End Intern",
    dateJoining: "2021",
    dateEnd: "2022",
    companyLogo:
      "dghub.jpeg",
    work: "At the onset of my journey as a front-end developer, I had the privilege of joining the dynamic team at DG Hub Nepal, a branch of Nepal Payment Solution. This pivotal role marked the beginning of my foray into the world of web development and laid the foundation for my future endeavors.",
  },
  {
    company: "Baliyo Ventures",
    designation: "Front End Developer",
    dateJoining: "2022",
    dateEnd: "2023",
    companyLogo:
      "baliyo-venture.png",
    work: "Joining the innovative team at Baliyo Ventures has been a pivotal step in my career, propelling me into a realm where I've not only expanded my front-end expertise but also delved into the intricate world of back-end development and API integration.",
  },
];